import {Injectable} from '@angular/core';
import { ConnectionBackend,
        RequestOptions,
        Request,
        RequestOptionsArgs,
        Response,
        Http,
        Headers} from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { catchError } from 'rxjs/operators';
import { environment } from '../environments/environment';

@Injectable()
export class InterceptedHttp extends Http {
  constructor(backend: ConnectionBackend, defaultOptions: RequestOptions) {
      super(backend, defaultOptions);
  }

  request(url: string | Request, options?: RequestOptionsArgs): Observable<Response> {
    console.log('My new request...');
    console.log(url);
    console.log(options);

    return super.request(url, options).pipe(
      catchError((error: Response) => {
        if (error.status == 401) {
          window.location.href = environment.restBaseRedirect + 'home';
        }
        return Observable.throw(error);
      })
    );
  }

  get(url: string, flag?: string, options?: RequestOptionsArgs): Observable<Response> {
    console.log('GET');
      return super.get(url, this.getRequestOptionArgs(options));
  }


  post(url: string, body: string, flag?: string, options?: RequestOptionsArgs, ): Observable<Response> {
      console.log('POST');
        return super.post(url, body, this.getRequestOptionArgs(options));
  }



  put(url: string, body: string, options?: RequestOptionsArgs): Observable<Response> {
    console.log('PUT');
      return super.put(url, body, this.getRequestOptionArgs(options));
  }


  delete(url: string, options?: RequestOptionsArgs): Observable<Response> {
    console.log('DELETE');
    return super.delete(url, this.getRequestOptionArgs(options));
  }

  getRequestOptionArgs(options?: RequestOptionsArgs): RequestOptionsArgs {
    console.log('getRequestOptions');
        if (options == null) {
            options = new RequestOptions();
        }
        if (options.headers == null) {
            options.headers = new Headers();
        }

      options.headers.append('X-Auth-Token', localStorage.getItem('token'));
        console.log(options);
        console.log("Token" , localStorage.getItem('token'))


        return options;
    }
}



// WEBPACK FOOTER //
// ./src/app/http.interceptors.ts